import { jsx as _jsx } from "react/jsx-runtime";
import SupportForm from "@/components/pages/support/form";
import NewDistributorModalZoho from "@/components/pages/branches/whereToBuy/newDistributorModal/old";
export default function NewDistributorModal(param) {
    let {} = param;
    return /*#__PURE__*/ _jsx(NewDistributorModalZoho, {});
}
